import { useContext, useState } from "react"
import { AppContext } from "../context/AppContext";


function Support() {

    const { support, setSupport } = useContext(AppContext);

    const [position, setPosition] = useState('left')

    const render = () => (
        <div className="guide" style={{ right: position === 'left' ? '16px' : '', left: position === 'right' ? '16px' : '' }}>
            <div className="guide-header">
                <div className="row align-items-center m-2">
                    <div className="col-sm">
                        <h4 className="m-0">Crear nuevos usuarios</h4>
                    </div>
                    <div className="col-sm-auto d-flex justify-content-end">
                        <button type="button" className="btn bg-soft-info-alternative btn-icon text-white-dark" onClick={() => setPosition(position === 'left' ? 'right' : 'left')}>
                            <i className={`bi-chevron-bar-${position}`}></i>
                        </button>
                        <button type="button" className="btn bg-soft-info-alternative btn-icon ms-2 text-white-dark" onClick={ () => setSupport( s => ({...s, show: false }))}>
                            <i className="bi-x-lg"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="guide-body">
                <iframe src={support.link} width="100%" height="100%" allowFullScreen frameBorder="0"></iframe>
            </div>
        </div>
    )
    return support.show ? render() : null;
}
export default Support